{
  "AUTHORIZED_INDIVIDUAL": "Authorized Individual",
  "BENEFICIAL_OWNER": "Beneficial Owner",
  "CHILD": "Child",
  "FRIEND": "Friend",
  "GRANDCHILD": "Grandchild",
  "GRANDPARENT": "Grandparent",
  "GRANTOR": "Grantor",
  "NIECE_NEPHEW": "Niece/Nephew",
  "OTHER": "Other",
  "PARENT": "Parent",
  "POWER_OF_ATTORNEY": "Power of Attorney",
  "PROTECTOR": "Protector",
  "SETTLOR": "Settlor",
  "SIBLING": "Sibling",
  "SPOUSE": "Spouse",
  "THIRD_PARTY": "Third Party",
  "TRUSTED_CONTACT": "Trusted Contact",
  "TRUSTEE": "Trustee",
  "DIRECTOR": "Director",
  "SENIOR_OFFICER": "Senior Officer"
}
